import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteAvatarsDefensive = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({id, url}: { id: string; url: string }) => {
			try {
				await api.delete(`/agricultural-defensives/deleteAvatarByUrl/${id}`, { params: { url } });
			} catch (error) {
				throw toApiError(error, 'Erro ao apagar avatar do defensivo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['defensives'] });
			queryClient.invalidateQueries({ queryKey: ['defensive'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao apagar avatar do defensivo:',
				getApiErrorMessage(error, 'Erro ao apagar avatar do defensivo')
			),
	});
};
